import { Link } from "react-router-dom";
import { FaBars } from "react-icons/fa6";
import { useState } from "react";
import { useLocation } from "react-router-dom";
import Logo from "../assets/Final-logo 1.png";
// import { FaTimes } from "react-icons/fa";
import { FaTimes } from "react-icons/fa";

import icon from "../assets/svg/phone.svg";
import { CiInstagram } from "react-icons/ci";
import { FaFacebookF, FaLinkedinIn } from "react-icons/fa";

export default function Navbar() {
  const location = useLocation();
  const [open, close] = useState(false);

  const click = () => {
    close(!open);
  };

  const navLink = [
    { name: "home", link: "/" },
    { name: "about us", link: "/about" },
    { name: "SERVICES", link: "/service" },
    { name: "CAREERS", link: "/careers" },
    { name: "CONTACT us", link: "/contact" },
  ];
  return (
    <>
      <div className="bg-[#202020] text-white w-full ">
        <div className=" mx-auto flex justify-between items-center max-md:px-5 lg:max-w-[1224px] md:max-w-[720px] max-w-full relative">
          <div className="lg:hidden block">
            <FaBars onClick={click} className="text-3xl" />
          </div>
          <div className="lg:flex hidden space-x-6 items-center ">
            <div className="">
              <Link
                to="/"
                aria-label="facebook">
                <img src={Logo} alt="Al Hathboor Group" class="h-full z-[999999]" />

              </Link>
            </div>

            <Link
              to="/" target="_blank"
              aria-label="facebook"
              className="w-[35px] h-[35px] flex items-center justify-center duration-300 rounded-full border border-white text-white hover:bg-white hover:text-[#A52323]"
            >
              <FaFacebookF className="text-lg font-medium" />
            </Link>
            <Link
              to="/" target="_blank"
              aria-label="instagram"
              className="w-[35px] h-[35px] flex items-center justify-center duration-300 rounded-full border border-white text-white hover:bg-white hover:text-[#A52323]"
            >
              <CiInstagram className="text-lg font-medium" />
            </Link>
            {/* <Link
              to="/"
              className="hover:text-red-600 transition-colors duration-300"
            >
              <img
                src="https://file.rendit.io/n/6gaT3XiTsangAeN3Q7EP.svg"
                alt="Flickr"
                className="w-6"
              />
            </Link> */}
            <Link
              to="/" target="_blank"
              aria-label="linkedin"
              className="w-[35px] h-[35px] flex items-center justify-center duration-300 rounded-full border border-white text-white hover:bg-white hover:text-[#A52323]"
            >
              <FaLinkedinIn className="text-lg font-medium" />
            </Link>
          </div>
          <nav className="hidden lg:flex space-x-8">
            <Link
              to="/"
              className={`hover:text-red-600 transition-colors duration-300 ${location.pathname === "/" ? "text-red-600" : ""
                }`}
            >
              <p> HOME</p>
            </Link>
            <Link
              to="/about"
              className={`hover:text-red-600 transition-colors duration-300 ${location.pathname === "/about" ? "text-red-600" : ""
                }`}
            >
              <p> ABOUT US</p>
            </Link>
            <Link
              to="/service"
              className={`hover:text-red-600 transition-colors duration-300 ${location.pathname === "/service" ? "text-red-600" : ""
                }`}
            >
              <p> SERVICES</p>
            </Link>
            <Link
              to="/careers"
              className={`hover:text-red-600 transition-colors duration-300 ${location.pathname === "/careers" ? "text-red-600" : ""
                }`}
            >
              <p> CAREERS</p>
            </Link>
            <Link
              to="/contact"
              className={`hover:text-red-600 transition-colors duration-300 ${location.pathname === "/contact" ? "text-red-600" : ""
                }`}
            >
              <p> CONTACT US</p>
            </Link>
          </nav>

          <div className="hidden lg:block">
            <a
              aria-label="email"
              href="tel:+96822700070"
              className="flex items-center px-6 py-3 bg-[#a52323] hover:bg-red-700 transition-colors"
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18.9766 14.8633C18.7267 14.6134 18.4573 14.4221 18.1684 14.2894C17.8795 14.1566 17.5788 14.0902 17.2664 14.0902C16.9541 14.0902 16.6534 14.1566 16.3645 14.2894C16.0755 14.4221 15.7983 14.6134 15.5328 14.8633L13.9398 16.4564C13.8773 16.4252 13.8109 16.3939 13.7406 16.3627C13.6703 16.3315 13.604 16.2924 13.5415 16.2456C13.4634 16.2143 13.3814 16.1753 13.2955 16.1284C13.2096 16.0816 13.1276 16.0347 13.0495 15.9879C12.2998 15.5193 11.5814 14.9688 10.8942 14.3362C10.207 13.7037 9.53542 12.9892 8.87945 12.1926C8.56709 11.7866 8.30158 11.4117 8.08292 11.0681C7.86427 10.7245 7.67685 10.3809 7.52067 10.0373C7.7237 9.84989 7.92283 9.65857 8.11806 9.46334C8.31329 9.26811 8.50461 9.07679 8.69203 8.88937C8.7545 8.81128 8.82479 8.73709 8.90288 8.66681C8.98097 8.59653 9.05125 8.52234 9.11372 8.44425C9.64474 7.91323 9.91025 7.33145 9.91025 6.69892C9.91025 6.06638 9.64474 5.4846 9.11372 4.95358L7.73151 3.57137C7.65342 3.49327 7.57533 3.41128 7.49724 3.32538C7.41915 3.23948 7.34106 3.15748 7.26296 3.07939C7.10678 2.92321 6.9506 2.76703 6.79442 2.61085C6.63824 2.45466 6.48205 2.29848 6.32587 2.1423C6.07598 1.89241 5.80657 1.70499 5.51763 1.58004C5.22869 1.4551 4.92804 1.39262 4.61568 1.39262C4.30331 1.39262 4.00266 1.4551 3.71372 1.58004C3.42479 1.70499 3.15537 1.89241 2.90548 2.1423C2.90548 2.1423 2.89767 2.1423 2.88205 2.1423L1.17186 3.89935C0.843875 4.21171 0.590079 4.56703 0.410469 4.96529C0.23086 5.36356 0.117627 5.78915 0.0707727 6.24208C0.00829984 6.97614 0.0590591 7.67115 0.22305 8.32712C0.387042 8.98308 0.554938 9.53753 0.726738 9.99046C1.13281 11.0993 1.65212 12.1809 2.28466 13.2351C2.91719 14.2894 3.68639 15.3631 4.59225 16.4564C5.1545 17.128 5.74019 17.7527 6.3493 18.3306C6.95841 18.9241 7.59485 19.4824 8.25863 20.0056C8.9224 20.5289 9.6057 21.0091 10.3085 21.4464C11.027 21.8993 11.7688 22.3054 12.5341 22.6646C13.112 22.9458 13.7797 23.223 14.5372 23.4963C15.2946 23.7696 16.1107 23.9375 16.9853 24C17.0322 24 17.0829 24 17.1376 24C17.1922 24 17.2508 24 17.3133 24C17.8912 24 18.4261 23.8946 18.9181 23.6837C19.41 23.4729 19.8434 23.1566 20.2183 22.7349C20.2339 22.7349 20.2417 22.7349 20.2417 22.7349C20.2417 22.7349 20.2417 22.7271 20.2417 22.7115C20.3823 22.5553 20.5267 22.403 20.6751 22.2547C20.8235 22.1063 20.9758 21.954 21.1319 21.7978C21.2413 21.7041 21.3506 21.6026 21.4599 21.4933C21.5693 21.3839 21.6786 21.2668 21.7879 21.1419C22.0378 20.892 22.2291 20.6187 22.3619 20.3219C22.4946 20.0252 22.561 19.7206 22.561 19.4082C22.561 19.0959 22.4946 18.7913 22.3619 18.4946C22.2291 18.1978 22.03 17.9167 21.7645 17.6512L18.9766 14.8633ZM20.804 20.2048C20.6946 20.3141 20.5892 20.4156 20.4877 20.5093C20.3862 20.603 20.2808 20.7046 20.1714 20.8139C20.0152 20.9701 19.8513 21.1341 19.6795 21.3059C19.5077 21.4777 19.3437 21.6495 19.1875 21.8213C18.9376 22.1024 18.6565 22.3093 18.3441 22.4421C18.0317 22.5748 17.6803 22.6412 17.2899 22.6412C17.2586 22.6412 17.2235 22.6412 17.1844 22.6412C17.1454 22.6412 17.1024 22.6412 17.0556 22.6412C16.3059 22.5787 15.5914 22.4265 14.912 22.1844C14.2326 21.9423 13.6352 21.6963 13.1198 21.4464C12.4014 21.1028 11.7063 20.7202 11.0348 20.2985C10.3632 19.8768 9.71502 19.4239 9.0903 18.9397C8.46557 18.4555 7.86427 17.9323 7.28639 17.3701C6.70852 16.8078 6.16188 16.2143 5.64648 15.5896C4.78748 14.5432 4.06123 13.528 3.46774 12.544C2.87424 11.5601 2.38227 10.5527 1.99181 9.52191C1.75754 8.89718 1.59745 8.32712 1.51155 7.81171C1.42565 7.29631 1.39832 6.81215 1.42956 6.35922C1.46079 6.06247 1.53108 5.78915 1.6404 5.53926C1.74973 5.28937 1.91372 5.06291 2.13238 4.85987L3.84257 3.12625C3.96752 3.0013 4.09637 2.9115 4.22912 2.85683C4.36188 2.80217 4.49073 2.77484 4.61568 2.77484C4.77186 2.77484 4.91633 2.81388 5.04908 2.89197C5.18184 2.97007 5.28726 3.04816 5.36535 3.12625C5.52153 3.28243 5.67381 3.43471 5.82218 3.58308C5.97056 3.73145 6.12283 3.88373 6.27902 4.03991C6.35711 4.118 6.4391 4.2 6.525 4.2859C6.6109 4.3718 6.6929 4.4538 6.77099 4.53189L8.1532 5.9141C8.41871 6.17961 8.55147 6.44122 8.55147 6.69892C8.55147 6.95662 8.41871 7.21822 8.1532 7.48373C8.07511 7.56182 8.00093 7.63601 7.93064 7.70629C7.86036 7.77657 7.78617 7.85076 7.70808 7.92885C7.50505 8.14751 7.29811 8.35835 7.08726 8.56139C6.87641 8.76443 6.66166 8.95965 6.44301 9.14707C6.44301 9.16269 6.4391 9.1705 6.43129 9.1705C6.42348 9.1705 6.41958 9.1705 6.41958 9.1705C6.20093 9.38915 6.0916 9.6 6.0916 9.80304C6.0916 10.0061 6.11503 10.1779 6.16188 10.3184C6.16188 10.3341 6.16188 10.3458 6.16188 10.3536C6.16188 10.3614 6.16969 10.3653 6.18531 10.3653C6.35711 10.8026 6.57576 11.236 6.84127 11.6655C7.10678 12.095 7.42696 12.5518 7.80179 13.036H7.82522C8.51242 13.895 9.23086 14.6642 9.98053 15.3436C10.7302 16.023 11.5111 16.6204 12.3233 17.1358C12.417 17.1983 12.5185 17.2568 12.6278 17.3115C12.7372 17.3662 12.8387 17.4169 12.9324 17.4638C13.0261 17.5106 13.1159 17.5575 13.2018 17.6043C13.2877 17.6512 13.3697 17.698 13.4478 17.7449C13.4478 17.7449 13.4556 17.7488 13.4712 17.7566C13.4868 17.7644 13.4946 17.7683 13.4946 17.7683C13.5883 17.8152 13.6742 17.8503 13.7523 17.8738C13.8304 17.8972 13.9163 17.9089 14.01 17.9089C14.2131 17.9089 14.381 17.862 14.5137 17.7683C14.6465 17.6746 14.7285 17.6043 14.7597 17.5575L16.4933 15.8239C16.587 15.7302 16.7003 15.6443 16.833 15.5662C16.9658 15.4881 17.1103 15.449 17.2664 15.449C17.4226 15.449 17.5632 15.4881 17.6881 15.5662C17.8131 15.6443 17.9146 15.7223 17.9927 15.8004C17.9927 15.8161 17.9927 15.8239 17.9927 15.8239C17.9927 15.8239 18.0005 15.8239 18.0161 15.8239L20.804 18.6117C21.0539 18.8772 21.1788 19.1427 21.1788 19.4082C21.1788 19.6738 21.0539 19.9393 20.804 20.2048ZM12.9792 5.70325C13.6508 5.8282 14.2834 6.04295 14.8768 6.34751C15.4703 6.65206 16.0092 7.04642 16.4933 7.53059C16.9619 8.01475 17.3523 8.55358 17.6647 9.14707C17.9771 9.74056 18.1879 10.3653 18.2972 11.0213C18.3285 11.1931 18.4066 11.3297 18.5315 11.4312C18.6565 11.5328 18.8048 11.5835 18.9766 11.5835C18.9922 11.5835 19.0079 11.5835 19.0235 11.5835C19.0391 11.5835 19.0625 11.5835 19.0938 11.5835C19.2812 11.5523 19.4296 11.4586 19.5389 11.3024C19.6482 11.1462 19.6873 10.9744 19.656 10.787C19.5155 9.99046 19.2578 9.23297 18.8829 8.51453C18.5081 7.79609 18.0317 7.14794 17.4539 6.57006C16.876 5.99219 16.2278 5.51583 15.5094 5.141C14.7909 4.76616 14.0335 4.50846 13.2369 4.3679C13.0495 4.33666 12.8777 4.37571 12.7215 4.48503C12.5654 4.59436 12.4716 4.74273 12.4404 4.93015C12.4092 5.10195 12.4443 5.26594 12.5458 5.42213C12.6473 5.57831 12.7918 5.67202 12.9792 5.70325ZM23.9901 10.5996C23.8808 9.92798 23.7168 9.27983 23.4981 8.6551C23.2951 8.03037 23.0413 7.42516 22.7367 6.83948C22.4322 6.2538 22.0847 5.68764 21.6942 5.141C21.2881 4.60998 20.8508 4.10239 20.3823 3.61822C19.8981 3.14968 19.3905 2.72017 18.8595 2.32972C18.3129 1.92365 17.7467 1.57224 17.161 1.27549C16.5753 0.978743 15.9701 0.721041 15.3454 0.502386C14.7207 0.299349 14.0803 0.135359 13.4244 0.0104122C13.2369 -0.0208244 13.0651 0.0182209 12.909 0.127548C12.7528 0.236876 12.6591 0.38525 12.6278 0.572668C12.5966 0.760086 12.6356 0.931887 12.745 1.08807C12.8543 1.24425 13.0027 1.33796 13.1901 1.3692C14.3771 1.57224 15.4977 1.94707 16.5519 2.49371C17.6061 3.04035 18.5627 3.74317 19.4218 4.60217C20.2808 5.44555 20.9836 6.39826 21.5302 7.4603C22.0768 8.52234 22.4439 9.63905 22.6313 10.8104C22.6625 10.9822 22.7445 11.1189 22.8773 11.2204C23.01 11.3219 23.1545 11.3727 23.3107 11.3727C23.3419 11.3727 23.3654 11.3727 23.381 11.3727C23.3966 11.3727 23.4122 11.3727 23.4278 11.3727C23.6152 11.3414 23.7636 11.2477 23.8729 11.0915C23.9823 10.9354 24.0213 10.7714 23.9901 10.5996Z" fill="white" />
              </svg>

              <p className="text-white text-sm ml-3  uppercase tracking-[0.16] leading-[24px]">
                Let's Talk
              </p>
            </a>
          </div>

          {/* phone view */}
          <div className="lg:hidden md:block  h-28 z-10">
            {/* <Link to="/">
              <img src={Logo} alt="Al Hathboor Group" class="h-28 top-0 z-10" />
            </Link> */}
          </div>

          <div className="lg:hidden block">
            <a aria-label="phone" href="tel:+96822700070" className="text-decoration-none ">
              <img src={icon} alt="icon" />
            </a>
          </div>
        </div>
      </div>
      {open && (
        <div className="lg:hidden block px-4 py-3 bg-[#202020] h-[100vh] fixed top-0 w-full z-10 ">
          <div>
            <button
              className="border-0 bg-transparent"
              onClick={() => close(false)}
            >
              <FaTimes className="text-3xl text-white " />
            </button>
          </div>
          <nav>
            <ul className="flex flex-col gap-5 py-5">
              {navLink.map((item, i) => (
                <li key={i}>
                  <Link
                    aria-label="link"
                    to={item.link}
                    className="uppercase text-white active:text-red-600 text-base font-medium"
                    onClick={() => close(false)}
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
        </div>
      )}
    </>
  );
}
